/*=========================================================================================
	File Name: moduleAuthMutations.js
	Description: Auth Module Mutations
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'
import state2 from "../state"
export default {
	SHELF_TRANS_CORRIDOR_LIST(state, value) {
		state.ShelfTransCorri = value;
	},
	UPDATE_STOCK_ON_SHELF(state, payload) {
		const index = state.StockOnShelf.findIndex(i => i.barcode === payload.barcode)
		state.StockOnShelf[index].quantity = parseFloat(state.StockOnShelf[index].quantity) + parseFloat(payload.quantity)
		if (state.StockOnShelf[index].quantity < 0) { state.StockOnShelf[index].quantity = 0; state.StockOnShelf.splice(index, 1); }
		//		localStorage.setItem("acceptedBarcodes", JSON.stringify(state.StockOnShelf));
	},
	ADD_STOCK_ON_SHELF(state, item) {
		console.log(item)
		let itemLocal = {
			shelfTransId: item.item.shelfTransId,
			barcode: item.item.barcode,
			stockName: item.value.StockName,
			stockNo: item.value.Stockno,
			quantity: item.item.quantity,
			shelfTransStatus: item.item.shelfTransStatus,
			corridorName: item.item.corridorName,
			corridorCode: item.item.corridorCode,
			corridorId: item.item.corridorId,
			shelfName: item.item.shelfName,
			shelfCode: item.item.shelfCode,
			shelfId: item.item.shelfId,
			companyName: item.item.companyName,
			companyCode: item.item.companyCode,
			companyId: item.item.companyId
		}
		if (state.StockOnShelf) {
			state.StockOnShelf.push(Object.assign({}, itemLocal))
		}
	},
	REMOVE_STOCK_ON_SHELF(state, item) {
		console.log(item)
		console.log(state.StockOnShelf)
		const index = state.StockOnShelf.findIndex(i => i.barcode === item)
		console.log(index)
		if (index > -1) { state.StockOnShelf.splice(index, 1) }
		//	localStorage.setItem("acceptedBarcodes", JSON.stringify(state.StockOnShelf));
	},
	REMOVE_ALL_STOCK_ON_SHELF(state, item) {
		state.StockOnShelf = []
		//	localStorage.setItem("acceptedBarcodes", JSON.stringify(state.AcceptedBarcodes));
	},
	STOCK_ON_SHELF(state, value) {
		state.StockOnShelf = value;
	},
	SHELF_TRANS_LIST(state, value) {
		state.ShelfTrans = value;
	},
	SHELF_ALL_LIST(state, value) {
		state.ShelfAll = value;
	},
	SHELF_LIST(state, value) {
		state.Shelf = value;
	},
	CORRIDOR_LIST(state, value) {
		state.Corridor = value;
	},
	USINGDEPOT_LIST(state, value) {
		state.UsingDepot = value;
	},
	DEPOTALLOW_LIST(state, value) {
		state.DepotAllow = value;
	},
	STOREHOUSE_TYPE_LIST(state, value) {
		state.StorehouseTypes = value;
	},
	STOREHOUSE_LIST(state, value) {
		state.Storehouse = value;
	},
	STOREHOUSE_COMPANY_LIST(state, value) {
		state.StorehouseForCompany = value;
	},
	STOREHOUSEDETAIL_LIST_FOR_STOREHOUSE(state, value) {
		state.StorehouseDetailsForStorehouse = value;
	}, CUSTOMER_INFO_LIST_FOR_CUSTOMER(state, value) {
		state.StorehouseForDepot = value;
	},
	ADD_ITEM_STOREHOUSE(state, item) {
		const output = Object.entries(item).map(([key, value]) => [
			key[0].toUpperCase() + key.slice(1), value,]);
		if (state2.AppActiveUser.ROLE == "Company") state.StorehouseForCompany.push(Object.assign({}, Object.fromEntries(output)))
		else state.Storehouse.push(Object.assign({}, Object.fromEntries(output)))
	},
	DELETE_ITEM_STOREHOUSE(state, item) {
		if (state2.AppActiveUser.ROLE == "Company") {
			const index = state.StorehouseForCompany.findIndex(i => i.DepotId === item)
			if (index > -1) { state.StorehouseForCompany.splice(index, 1) }
		} else {
			const index = state.Storehouse.findIndex(i => i.DepotId === item)
			if (index > -1) { state.Storehouse.splice(index, 1) }
		}
	},
	CARGO_LIST(state, value) {
		state.Cargo = value;
	},

}
